import { SwivuSortedGroupersMixin } from "./mixins/SwivuSortedGroupersMixin";
import { SwivuStoreArchiveMixin } from "./mixins/SwivuStoreArchiveMixin";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";
import { Store } from "@bryntum/schedulerpro";
import { OutcomeIncentive } from "../models/OutcomeIncentive.jsx";

export class SwivuOutcomeIncentiveStore extends SwivuSortedGroupersMixin(SwivuStoreArchiveMixin(Store)) {
  static get $name() {
    return "SwivuOutcomeIncentiveStore";
  }

  static get configurable() {
    return {
      modelClass: OutcomeIncentive,
      id: STORE_KEYS.outcomeIncentiveStore,
      storeId: STORE_KEYS.outcomeIncentiveStore
    };
  }
}